
import React, { useState } from 'react';
import Button from '../../../components/base/Button';

export default function WorkshopsSection() {
  const [activeCategory, setActiveCategory] = useState('villages');
  const [showWorkshopFinder, setShowWorkshopFinder] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedLocation, setSelectedLocation] = useState('all');

  const workshopCategories = [
    { id: 'villages', label: 'Village Workshops', icon: 'ri-home-4-line' },
    { id: 'schools', label: 'School Programs', icon: 'ri-school-line' },
    { id: 'healthcare', label: 'Healthcare Centers', icon: 'ri-hospital-line' }
  ];

  const villageWorkshops = [
    {
      title: 'Rural Health Awareness Camp',
      location: 'Haryana Villages',
      participants: '500+ villagers planned',
      duration: '2 days',
      date: 'March 15-16, 2024',
      status: 'Registration Open',
      image: 'https://public.readdy.ai/ai/img_res/205d5541640c1387cd3cbefd45bcb751.jpg',
      highlights: ['Basic oxygen health screening', 'Breathing exercise training', 'Early warning sign recognition', 'Home remedy guidance']
    },
    {
      title: 'Women\'s Health Circle',
      location: 'Rajasthan Communities',
      participants: '200+ women planned',
      duration: '1 day',
      date: 'March 22, 2024',
      status: 'Registration Open',
      image: 'https://readdy.ai/api/search-image?query=Women%20health%20education%20workshop%20in%20rural%20setting%20with%20Indian%20women%20sitting%20in%20circle%20learning%20about%20oxygen%20health%20from%20female%20healthcare%20educator%2C%20colorful%20traditional%20clothing%2C%20interactive%20community%20health%20education%20session&width=400&height=300&seq=women-workshop&orientation=landscape',
      highlights: ['Maternal oxygen health', 'Child health awareness', 'Nutrition guidance', 'Self-care techniques']
    },
    {
      title: 'Farmer Health Initiative',
      location: 'Punjab Agricultural Areas',
      participants: '300+ farmers planned',
      duration: 'Half day',
      date: 'March 28, 2024',
      status: 'Registration Open',
      image: 'https://readdy.ai/api/search-image?query=Healthcare%20workshop%20for%20farmers%20in%20agricultural%20setting%2C%20men%20and%20women%20farmers%20learning%20about%20occupational%20health%20and%20oxygen%20awareness%2C%20outdoor%20educational%20session%20with%20farming%20community%20and%20medical%20professionals%20in%20rural%20Punjab&width=400&height=300&seq=farmer-workshop&orientation=landscape',
      highlights: ['Occupational health risks', 'Dust exposure protection', 'Physical wellness for farmers', 'Emergency first aid']
    }
  ];

  const schoolPrograms = [
    {
      title: 'Healthy Breathing for Kids',
      location: 'Government Schools',
      participants: '5,000+ students planned',
      duration: '1 hour sessions',
      date: 'April 5-12, 2024',
      status: 'Registration Open',
      image: 'https://readdy.ai/api/search-image?query=School%20children%20in%20classroom%20learning%20about%20breathing%20and%20oxygen%20health%20from%20teacher%2C%20colorful%20educational%20materials%20about%20lungs%20and%20breathing%2C%20interactive%20school%20health%20education%20program%20with%20diverse%20students%20engaged%20in%20learning&width=400&height=300&seq=school-program&orientation=landscape',
      highlights: ['Age-appropriate health education', 'Fun breathing games', 'Health habit formation', 'Take-home materials']
    },
    {
      title: 'Teacher Training Program',
      location: 'Educational Institutions',
      participants: '1,200+ teachers planned',
      duration: '3 hours',
      date: 'April 18, 2024',
      status: 'Registration Open',
      image: 'https://readdy.ai/api/search-image?query=Teachers%20attending%20health%20education%20training%20workshop%2C%20professional%20development%20session%20about%20oxygen%20health%20education%20for%20educators%2C%20classroom%20setting%20with%20teachers%20learning%20to%20teach%20health%20concepts%20to%20children&width=400&height=300&seq=teacher-training&orientation=landscape',
      highlights: ['Curriculum integration', 'Health screening basics', 'Student wellness protocols', 'Parent communication']
    },
    {
      title: 'Student Health Ambassadors',
      location: 'High Schools',
      participants: '800+ students planned',
      duration: '2 days',
      date: 'April 25-26, 2024',
      status: 'Registration Open',
      image: 'https://readdy.ai/api/search-image?query=High%20school%20students%20being%20trained%20as%20health%20ambassadors%2C%20teenage%20students%20learning%20peer%20education%20about%20oxygen%20health%2C%20youth%20leadership%20training%20program%20in%20school%20setting%20with%20engaged%20adolescents&width=400&height=300&seq=student-ambassadors&orientation=landscape',
      highlights: ['Peer education training', 'Leadership development', 'Community outreach skills', 'Health advocacy']
    }
  ];

  const healthcareWorkshops = [
    {
      title: 'PHC Staff Certification',
      location: 'Primary Health Centers',
      participants: '2,000+ staff planned',
      duration: 'Full day',
      date: 'May 8, 2024',
      status: 'Registration Open',
      image: 'https://readdy.ai/api/search-image?query=Healthcare%20professionals%20attending%20training%20workshop%20in%20medical%20facility%2C%20doctors%20and%20nurses%20learning%20advanced%20oxygen%20health%20protocols%2C%20professional%20medical%20education%20session%20with%20clinical%20training%20equipment%20and%20educational%20materials&width=400&height=300&seq=healthcare-training&orientation=landscape',
      highlights: ['Advanced screening techniques', 'Treatment protocols', 'Equipment usage', 'Documentation standards']
    },
    {
      title: 'ASHA Worker Training',
      location: 'Community Health Centers',
      participants: '3,500+ workers planned',
      duration: '2 days',
      date: 'May 15-16, 2024',
      status: 'Registration Open',
      image: 'https://readdy.ai/api/search-image?query=ASHA%20community%20health%20workers%20in%20training%20session%20learning%20oxygen%20health%20education%20techniques%2C%20Indian%20female%20health%20workers%20in%20traditional%20dress%20attending%20professional%20development%20workshop%20with%20medical%20trainers&width=400&height=300&seq=asha-training&orientation=landscape',
      highlights: ['Community screening methods', 'Referral protocols', 'Health education delivery', 'Record keeping']
    },
    {
      title: 'Mobile Health Unit Training',
      location: 'Regional Centers',
      participants: '500+ staff planned',
      duration: '3 days',
      date: 'May 22-24, 2024',
      status: 'Registration Open',
      image: 'https://readdy.ai/api/search-image?query=Mobile%20health%20unit%20training%20with%20healthcare%20workers%20learning%20to%20operate%20medical%20van%20equipment%2C%20professional%20medical%20training%20around%20mobile%20healthcare%20vehicle%20with%20oxygen%20monitoring%20devices%20and%20educational%20materials&width=400&height=300&seq=mobile-unit-training&orientation=landscape',
      highlights: ['Mobile equipment operation', 'Field screening protocols', 'Data collection', 'Emergency procedures']
    }
  ];

  const getCurrentWorkshops = () => {
    switch (activeCategory) {
      case 'villages': return villageWorkshops;
      case 'schools': return schoolPrograms;
      case 'healthcare': return healthcareWorkshops;
      default: return villageWorkshops;
    }
  };

  const getAllWorkshops = () => {
    return [...villageWorkshops, ...schoolPrograms, ...healthcareWorkshops];
  };

  const getFilteredWorkshops = () => {
    let workshops = getAllWorkshops();
    
    if (searchQuery) {
      workshops = workshops.filter(workshop => 
        workshop.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
        workshop.location.toLowerCase().includes(searchQuery.toLowerCase()) ||
        workshop.highlights.some(h => h.toLowerCase().includes(searchQuery.toLowerCase()))
      );
    }
    
    if (selectedLocation !== 'all') {
      workshops = workshops.filter(workshop => 
        workshop.location.toLowerCase().includes(selectedLocation.toLowerCase())
      );
    }
    
    return workshops;
  };

  const locations = ['Haryana', 'Rajasthan', 'Punjab', 'Government Schools', 'Educational Institutions', 'High Schools', 'Primary Health Centers', 'Community Health Centers', 'Regional Centers'];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center max-w-4xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#111111] mb-6">
            Planned Community Workshops
          </h2>
          <p className="text-xl text-gray-700 leading-relaxed">
            Upcoming interactive workshops and training programs to be delivered directly to villages, 
            schools, and healthcare centers to build oxygen health awareness at the grassroots level.
          </p>
        </div>

        {/* Category Tabs */}
        <div className="flex justify-center mb-12">
          <div className="bg-[#FAFAFA] p-1 rounded-2xl flex flex-wrap justify-center gap-1">
            {workshopCategories.map((category) => (
              <button
                key={category.id}
                onClick={() => setActiveCategory(category.id)}
                className={`flex items-center space-x-2 px-6 py-3 rounded-xl font-medium transition-all duration-200 whitespace-nowrap ${
                  activeCategory === category.id
                    ? 'bg-[#12B6B6] text-white shadow-lg'
                    : 'text-gray-600 hover:text-[#12B6B6]'
                }`}
              >
                <i className={`${category.icon} text-lg`}></i>
                <span>{category.label}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Workshop Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {getCurrentWorkshops().map((workshop, index) => (
            <div 
              key={index}
              className="group bg-[#FAFAFA] rounded-2xl overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img 
                  src={workshop.image} 
                  alt={workshop.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-[#111111] mb-2">{workshop.title}</h3>
                
                <div className="flex items-center space-x-4 text-sm text-gray-600 mb-4">
                  <div className="flex items-center space-x-1">
                    <i className="ri-map-pin-line w-4 h-4 flex items-center justify-center text-[#12B6B6]"></i>
                    <span>{workshop.location}</span>
                  </div>
                  <div className="flex items-center space-x-1">
                    <i className="ri-time-line w-4 h-4 flex items-center justify-center text-[#12B6B6]"></i>
                    <span>{workshop.duration}</span>
                  </div>
                </div>

                <div className="flex items-center space-x-2 mb-4">
                  <i className="ri-team-line w-4 h-4 flex items-center justify-center text-[#12B6B6]"></i>
                  <span className="text-sm font-medium text-[#12B6B6]">{workshop.participants}</span>
                </div>

                <div className="space-y-2">
                  <h4 className="font-semibold text-[#111111] text-sm">Workshop Highlights:</h4>
                  <ul className="space-y-1">
                    {workshop.highlights.map((highlight, highlightIndex) => (
                      <li key={highlightIndex} className="flex items-start space-x-2 text-xs text-gray-600">
                        <i className="ri-check-line w-3 h-3 flex items-center justify-center text-[#12B6B6] mt-0.5"></i>
                        <span>{highlight}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Quick Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
          <button
            onClick={() => setShowWorkshopFinder(true)}
            className="inline-flex items-center justify-center font-medium rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer border-2 border-[#12B6B6] text-[#12B6B6] hover:bg-[#12B6B6] hover:text-white px-4 py-2 text-sm"
          >
            Find Workshops
          </button>
          <button
            onClick={() => {
              const newsletterSection = document.querySelector('[data-newsletter-section]');
              if (newsletterSection) {
                newsletterSection.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            className="inline-flex items-center justify-center font-medium rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer border-2 border-[#12B6B6] text-[#12B6B6] hover:bg-[#12B6B6] hover:text-white px-4 py-2 text-sm"
          >
            Subscribe Now
          </button>
          <Button variant="outline" size="sm">
            Browse Library
          </Button>
        </div>

        {/* Impact Stats */}
        <div className="bg-gradient-to-r from-[#12B6B6] to-[#0ea5a5] rounded-2xl p-8 md:p-12 text-white mb-12">
          <h3 className="text-3xl font-bold text-center mb-8">Planned Workshop Goals</h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold mb-2">500+</div>
              <div className="text-sm opacity-90">Workshops Planned</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold mb-2">75K+</div>
              <div className="text-sm opacity-90">People to Train</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold mb-2">300+</div>
              <div className="text-sm opacity-90">Villages to Reach</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold mb-2">95%</div>
              <div className="text-sm opacity-90">Target Satisfaction</div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center">
          <Button variant="primary" size="lg">
            Pre-register for Upcoming Workshops
          </Button>
        </div>
      </div>

      {/* Workshop Finder Modal */}
      {showWorkshopFinder && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-[100]">
          <div className="bg-white rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6 border-b border-gray-200">
              <div className="flex items-center justify-between">
                <h3 className="text-2xl font-bold text-[#111111]">Find Workshops</h3>
                <button
                  onClick={() => setShowWorkshopFinder(false)}
                  className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors cursor-pointer"
                >
                  <i className="ri-close-line text-xl"></i>
                </button>
              </div>
              
              {/* Search and Filter */}
              <div className="mt-6 space-y-4">
                <div className="relative">
                  <input
                    type="text"
                    placeholder="Search workshops by title, location, or topic..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-[#12B6B6] focus:border-transparent text-sm"
                  />
                  <i className="ri-search-line absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
                </div>
                
                <div className="flex items-center space-x-4">
                  <label className="text-sm font-medium text-gray-700">Filter by location:</label>
                  <select
                    value={selectedLocation}
                    onChange={(e) => setSelectedLocation(e.target.value)}
                    className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#12B6B6] focus:border-transparent text-sm pr-8"
                  >
                    <option value="all">All Locations</option>
                    {locations.map(location => (
                      <option key={location} value={location}>{location}</option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            <div className="p-6">
              <div className="space-y-4">
                {getFilteredWorkshops().length === 0 ? (
                  <div className="text-center py-8">
                    <i className="ri-search-line text-4xl text-gray-400 mb-4"></i>
                    <p className="text-gray-600">No workshops found matching your criteria.</p>
                  </div>
                ) : (
                  getFilteredWorkshops().map((workshop, index) => (
                    <div key={index} className="border border-gray-200 rounded-xl p-6 hover:shadow-md transition-shadow">
                      <div className="flex flex-col md:flex-row gap-4">
                        <div className="md:w-32 md:h-24 w-full h-48 rounded-lg overflow-hidden flex-shrink-0">
                          <img 
                            src={workshop.image} 
                            alt={workshop.title}
                            className="w-full h-full object-cover"
                          />
                        </div>
                        
                        <div className="flex-1">
                          <div className="flex items-start justify-between mb-2">
                            <h4 className="text-lg font-bold text-[#111111]">{workshop.title}</h4>
                            <span className="text-xs px-2 py-1 bg-green-100 text-green-800 rounded-full whitespace-nowrap">
                              {workshop.status}
                            </span>
                          </div>
                          
                          <div className="flex flex-wrap items-center gap-4 text-sm text-gray-600 mb-3">
                            <div className="flex items-center space-x-1">
                              <i className="ri-map-pin-line w-4 h-4 flex items-center justify-center text-[#12B6B6]"></i>
                              <span>{workshop.location}</span>
                            </div>
                            <div className="flex items-center space-x-1">
                              <i className="ri-calendar-line w-4 h-4 flex items-center justify-center text-[#12B6B6]"></i>
                              <span>{workshop.date}</span>
                            </div>
                            <div className="flex items-center space-x-1">
                              <i className="ri-time-line w-4 h-4 flex items-center justify-center text-[#12B6B6]"></i>
                              <span>{workshop.duration}</span>
                            </div>
                          </div>
                          
                          <div className="flex items-center space-x-2 mb-3">
                            <i className="ri-team-line w-4 h-4 flex items-center justify-center text-[#12B6B6]"></i>
                            <span className="text-sm font-medium text-[#12B6B6]">{workshop.participants}</span>
                          </div>
                          
                          <div className="flex flex-wrap gap-2 mb-4">
                            {workshop.highlights.slice(0, 3).map((highlight, highlightIndex) => (
                              <span key={highlightIndex} className="text-xs bg-gray-100 text-gray-700 px-2 py-1 rounded-full">
                                {highlight}
                              </span>
                            ))}
                            {workshop.highlights.length > 3 && (
                              <span className="text-xs text-gray-500">+{workshop.highlights.length - 3} more</span>
                            )}
                          </div>
                          
                          <div className="flex space-x-3">
                            <button className="text-sm px-4 py-2 bg-[#12B6B6] text-white rounded-lg hover:bg-[#0ea5a5] transition-colors cursor-pointer whitespace-nowrap">
                              Register Now
                            </button>
                            <button className="text-sm px-4 py-2 border border-[#12B6B6] text-[#12B6B6] rounded-lg hover:bg-[#12B6B6] hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                              Learn More
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
